import { render, staticRenderFns } from "./changeEmail.vue?vue&type=template&id=6840fd7c&"
import script from "./changeEmail.vue?vue&type=script&lang=js&"
export * from "./changeEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports